/**
 * Exporte une liste d'utilisateurs au format CSV
 * @param {Array} users - Liste des utilisateurs à exporter
 * @param {string} filename - Nom du fichier (optionnel)
 */
export const exportUsersToCSV = (users, filename) => {
  if (!users || users.length === 0) {
    alert('Aucun utilisateur à exporter');
    return;
  }

  const now = new Date();
  const exportDateTime = now.toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
  const exportDate = now.toLocaleDateString('fr-FR').replace(/\//g, '-');

  const headers = [
    'ID', 'Username', 'Email', 'Nom', 'Prénom', 'Rôle',
    'Organisation', 'Adresse', 'Pays', 'Ville', 'Statut',
  ];

  const escapeCell = (cell) => {
    const s = String(cell ?? '');
    return s.includes(',') || s.includes('"') || s.includes('\n')
      ? `"${s.replace(/"/g, '""')}"`
      : s;
  };

  const rows = users.map(user => [
    user.id          || '',
    user.username    || '',
    user.email       || '',
    user.name        || '',
    user.lastname    || '',
    user.role        || '',
    user.organization || '',
    user.adress  || '',
    user.country || '',
    user.city    || '',
    user.active ? 'Actif' : 'Inactif',
  ]);

  const csvContent = [
    `Date d'export :,${exportDateTime}`,
    '',                        
    headers.join(','),
    ...rows.map(row => row.map(escapeCell).join(',')),
  ].join('\n');

  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.setAttribute('href', URL.createObjectURL(blob));
  link.setAttribute('download', filename || `utilisateurs_${exportDate}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};